import type { MfgMaterial } from "@/lib/manufacturingClient";
import {
  newDraftLine,
  type PoDraftLine,
} from "@/components/manufacturing/purchaseOrderDraftState";
import {
  ghostBtnClass,
  inputClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";

export function PlantMaterialRequestSimpleLines(props: {
  lines: PoDraftLine[];
  onChange: (lines: PoDraftLine[]) => void;
  materials: MfgMaterial[];
  plantId: string;
  enabled: boolean;
  busy: boolean;
}) {
  const catalog = props.plantId
    ? props.materials.filter((m) => m.plant_id === props.plantId)
    : props.materials;

  return (
    <div className="space-y-2">
      <div className="text-xs font-semibold">From the material list (optional)</div>
      {props.lines.map((line, idx) => (
        <div key={line.key} className="flex flex-wrap items-end gap-2">
          <label className="min-w-[8rem] flex-1 text-[11px]">
            Item
            <input
              list="plant-request-materials"
              className={`${inputClass} mt-0.5 w-full`}
              value={line.material_name}
              disabled={!props.enabled || props.busy}
              placeholder="Pick or type a name"
              onChange={(e) => {
                const name = e.target.value;
                const match = catalog.find((m) => m.name === name || m.code === name);
                props.onChange(
                  props.lines.map((l, i) =>
                    i === idx
                      ? { ...l, material_name: name, material_id: match?.id ?? null }
                      : l,
                  ),
                );
              }}
            />
          </label>
          <label className="w-24 text-[11px]">
            Qty
            <input
              className={`${inputClass} mt-0.5 w-full`}
              value={line.quantity}
              disabled={!props.enabled || props.busy}
              onChange={(e) =>
                props.onChange(
                  props.lines.map((l, i) => (i === idx ? { ...l, quantity: e.target.value } : l)),
                )
              }
            />
          </label>
          <button
            type="button"
            className={ghostBtnClass}
            disabled={props.busy || props.lines.length <= 1}
            onClick={() => props.onChange(props.lines.filter((_, i) => i !== idx))}
          >
            Remove
          </button>
        </div>
      ))}
      <datalist id="plant-request-materials">
        {catalog.map((m) => (
          <option key={m.id} value={m.name} />
        ))}
      </datalist>
      <button
        type="button"
        className={ghostBtnClass}
        disabled={props.busy}
        onClick={() => props.onChange([...props.lines, newDraftLine()])}
      >
        + Add item
      </button>
    </div>
  );
}
